export default __webpack_public_path__ + "static/media/ilgi.7b93d540.png";